<script setup>
import { computed } from 'vue'

const props = defineProps({
  columns: { type: Array, default: () => [] },
  data: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  emptyMessage: { type: String, default: 'Aucune donnée à afficher.' },
  paginator: { type: Boolean, default: false },
  rows: { type: Number, default: 25 },
  totalRecords: { type: Number, default: 0 },
  lazy: { type: Boolean, default: false }
})

const emit = defineEmits(['page-change'])

const rowsPerPageOptions = [10, 25, 50, 100]

function onPage(event) {
  emit('page-change', { page: event.page, rows: event.rows })
}
</script>

<template>
  <!-- Loading state -->
  <div v-if="loading" class="w-full py-10 flex items-center justify-center gap-2 text-navy/40 text-sm">
    <i class="pi pi-spin pi-spinner text-lg"></i>
    <span>Chargement...</span>
  </div>

  <!-- Empty state -->
  <div v-else-if="!data || data.length === 0" class="w-full py-10 text-center text-sm text-navy/50">
    <slot name="empty">{{ emptyMessage }}</slot>
  </div>

  <!-- DataTable -->
  <DataTable
    v-else
    :value="data"
    :paginator="paginator"
    :rows="rows"
    :totalRecords="totalRecords > 0 ? totalRecords : data.length"
    :lazy="lazy"
    :rowsPerPageOptions="rowsPerPageOptions"
    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
    currentPageReportTemplate="{first}–{last} sur {totalRecords}"
    :loading="false"
    @page="onPage"
    class="w-full"
  >
    <Column
      v-for="col in columns"
      :key="col.field"
      :field="col.field"
      :header="col.header"
      :sortable="col.sortable || false"
      :style="col.minWidth ? { minWidth: col.minWidth } : {}"
    >
      <template #body="{ data: row }">
        <slot :name="'col-' + col.field" :row="row" :value="row[col.field]">
          {{ row[col.field] }}
        </slot>
      </template>
    </Column>

    <template #empty>
      <slot name="empty">
        <div class="text-center py-10 text-sm text-navy/50">{{ emptyMessage }}</div>
      </slot>
    </template>
  </DataTable>
</template>
